import type { RoleColor } from "./types";

import PromotionsIcon from "../../../assets/icons/ic_promotion.svg";
import StaffManagementIcon from "../../../assets/icons/ic_staff_management.svg";
import DashboardIcon from "../../../assets/icons/ic_dashboard.svg";
import PaymentsIcon from "../../../assets/icons/ic_payments.svg";
import ConfigurationsIconNew from "../../../assets/icons/ic_configuration_new.svg";
import ConfigurationsIcon from "../../../assets/icons/ic_configuration.svg";
import ReportsIcon from "../../../assets/icons/ic_reports.svg";
import TransactionsIcon from "../../../assets/icons/ic_transactions.svg";
import UsersIcon from "../../../assets/icons/ic_users.svg";
import LockIcon from "../../../assets/icons/ic_lock.svg";
import VerifiedIcon from "../../../assets/icons/ic_verified.svg";
import LineChartIcon from "../../../assets/icons/ic_line-chart.svg";
import SportsbookIcon from "../../../assets/icons/ic_sportsbook.svg";
import PikkemIcon from "../../../assets/icons/ic_pikkem.svg";
import CasinoIcon from "../../../assets/icons/ic_casino.svg";
import GamePassIcon from "../../../assets/icons/ic_game_pass.svg";
import PokerIcon from "../../../assets/icons/ic_poker.svg";

export const DEFAULT_COLORS: RoleColor[] = [
  { value: "#FFFFFF", label: "White", color: "#FFFFFF" },
  { value: "#3498DB", label: "Blue", color: "#3498DB" },
  { value: "#EC4899", label: "Pink", color: "#EC4899" },
  { value: "#D9D9D9", label: "Gray", color: "#D9D9D9" },
  { value: "#000000", label: "Black", color: "#000000" },
  { value: "#FF5733", label: "Orange", color: "#FF5733" },
  { value: "#FFD700", label: "Gold", color: "#FFD700" },
  { value: "#FFA500", label: "Orange", color: "#FFA500" },
  { value: "#6b7280", label: "Slate", color: "#6b7280" },
  { value: "#22c55e", label: "Green", color: "#22c55e" },
  { value: "#9B59B6", label: "Purple", color: "#9B59B6" },
];

// Permission keys hidden in all environments (UI only — values may still exist in DB)
export const HIDDEN_PERMISSION_KEYS: string[] = [
  "sportsbook.casino",
  "deployed_builds",
  "reports",
  "pikkem",
  "admin",
];

// Misnested categories (e.g. "staff_management.agent_audit_log") whose sub-items
// must be collapsed to a single toggle in the UI. Sub-items are recorded at fetch
// time and re-expanded on save so the backend still receives every key.
export const DISCARDED_SUBITEMS_KEYS: string[] = [
  "staff_management.agent_audit_log",
];

// Permission keys visible only in dev/test environments (hidden in prod/staging).
// Poker is WIP behind `developmentMode` on the Sider/routes — keep the category
// out of role editors outside FEATURE_GUARD_ALLOWED_ENVIRONMENTS.
export const DEV_ONLY_PERMISSION_KEYS: string[] = [
  "poker",
  "features",
];

export const SIDEBAR_ICONS: Record<string, string> = {
  kpis: LineChartIcon,
  users: UsersIcon,
  dashboard: DashboardIcon,
  transactions: TransactionsIcon,
  compliance: VerifiedIcon,
  sportsbook: SportsbookIcon,
  pikkem: PikkemIcon,
  casino: CasinoIcon,
  promotions: PromotionsIcon,
  configuration: ConfigurationsIconNew,
  configurations: ConfigurationsIcon,
  payments: PaymentsIcon,
  deployed_builds: ConfigurationsIcon,
  reports: ReportsIcon,
  staff_management: StaffManagementIcon,
  admin: LockIcon,
  features: GamePassIcon,
  poker: PokerIcon,
};
